<div *ngIf="minText || maxText" class="label-container">
  <label class="ols-heading-5">{{minText}}</label>
  <label class="ols-heading-5">{{maxText}}</label>
</div>
<input #rangeElement type="range" [id]="meetId" [min]="min" [max]="max" [step]="step" [(ngModel)]="value"
  (change)="onSliderChange($event)">
